module.exports = __webpack_public_path__ + "static/gallery_treehouse_1-e419717c245cc8c979da32a917ebd0b1.jpg";